import { Processo } from '@app/models/processo.model';
export class Publicacao {

  public Id: number;
  public DataImportacao: string;
  public GeradoMovimentacao: boolean;
  public DataGeracaoMovimentacao: string;
  // public Adogado: string;
  // public OABNumero: string;
  // public OABEstado: string;
  public Diario: string;
  public EdicaoDiario: string;
  public PaginaInicial: string;
  public DataPublicacao: string;
  public NProcesso: string;
  public CidadePublicacao: string;
  public Orgao: string;
  public Vara: string;
  public DespachoPublicacao: string;
  public ProcessoPublicacao: string;
  public UsuarioId: number;

  public Processo: Processo;
  public Anterior: number;
  public Proximo: number;
  public TotalPendente: number;
}
